import { noop } from "utils/noop";
import type { MiniMapConfig } from "./types";

export const DEFAULT_MINIMAP_CONFIG: MiniMapConfig = {
  minZoomWidth: 30,
  zoomInFactor: 0.9,
  zoomOutFactor: 1.12,
  wheel: {
    sensitivity: 0.0025,
    pixelMultiplier: 5,
    lineMultiplier: 40,
    maxDelta: 200,
  },
};

export const MINIMAP_DISABLED_HANDLERS = {
  cursor: "default",
  zoomIn: noop,
  zoomOut: noop,
  resetZoom: noop,
  onMouseDown: noop,
  onMouseMove: noop,
  onMouseUp: noop,
  onMouseLeave: noop,
} as const;

export const MINIMAP_INTERACTION_MODES = {
  VIEW: "view",
  EDIT: "edit",
} as const;

export const MINIMAP_CURSORS = {
  GRAB: "grab",
  GRABBING: "grabbing",
  CROSSHAIR: "crosshair",
  DEFAULT: "default",
} as const;
